<template>
    <DCard
        padding
    >
        <DTable
            :items="documents"
            :fields="fields"
            hover
            sorter
        >
            <template #name="{item}">
                <td>
                    {{ __(`tools.documents.document.${item.type}`) }}
                </td>
            </template>
            <template #samples="{item}">
                <td>
                    <DDropdown
                        id="select_sample"
                        :toggler-text="__('tools.documents.table.select-sample')"
                        color="secondary"
                    >
                        <DDropdownItem
                            v-for="(sample, index) in item.samples"
                            :id="`sample_${sample}`"
                            :key="index"
                            @click="openDocumentSampleModal(item.type, sample)"
                        >
                            {{ __(`tools.documents.samples.${item.type}.${sample}`) }}
                        </DDropdownItem>
                    </DDropdown>
                </td>
            </template>
        </DTable>
        <DocumentPreviewModal
            v-if="showModal"
            :show-modal="showModal"
            :document="chosenDocument"
            :sample="chosenSample"
            :brands="brands"
            :available-languages="availableLanguages"
            :market-regions="marketRegions"
            @closeModal="closeModal"
        />
    </DCard>
</template>

<script>
import DocumentPreviewModal from '~@/Components/Tools/Documents/DocumentPreviewModal'

export default {
    name: 'DocumentIndex',
    components: {
        DocumentPreviewModal
    },
    props: {
        brands: {
            type: Array,
            default: () => { return [] }
        },
        documents: {
            type: Array,
            default: () => { return [] }
        },
        availableLanguages: {
            type: Array,
            default: () => { return [] }
        },
        marketRegions: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            fields: [
                { key: 'name', label: this.__('tools.documents.table.name') },
                { key: 'samples', label: this.__('tools.documents.table.samples'), sorter: false, filter: false }
            ],
            showModal: false,
            chosenDocument: '',
            chosenSample: ''
        }
    },
    computed: {
        brandOptions () {
            return this.brands.map(brand => {
                return {
                    value: brand.id,
                    label: brand.name
                }
            })
        }
    },
    methods: {
        openDocumentSampleModal (document, sample) {
            this.chosenDocument = document
            this.chosenSample = sample
            this.showModal = true
        },
        closeModal () {
            this.showModal = false
        }
    }
}
</script>
